import clsx from "clsx";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ContentDivider } from "@atoms/contentDivider";
import { Icon } from "@atoms/icon";
import { Typography } from "@atoms/typography";
import { FastPhone } from "@components/fastFields/fastPhone";
import { Row } from "@layout/row";
import { FormLayout } from "@organisms/formLayout";
import {
  forgetPasswordFormInitialValues,
  forgetPasswordFormValidationSchema,
} from "@templates/authManagement/forgetPasswordForm/schema";
import { zodResolver } from "@utils/zod";

import classes from "./styles.module.scss";

import type { IFormTemplateProps } from "@interfaces";
import type { IForgetPasswordFormSchema } from "@templates/authManagement/forgetPasswordForm/schema";

export function ForgetPasswordForm({
  isLoading,
  onSubmit,
  initialValues,
}: IFormTemplateProps<IForgetPasswordFormSchema>) {
  const { t } = useTranslation("page");

  const { control, handleSubmit } = useForm<IForgetPasswordFormSchema>({
    defaultValues: initialValues || forgetPasswordFormInitialValues,
    resolver: zodResolver(forgetPasswordFormValidationSchema),
    mode: "onChange",
  });

  return (
    <div className={clsx(classes.loginForm)}>
      <div className={clsx(classes.loginForm__head)}>
        <div className={clsx(classes.loginForm__circleOutside)}>
          <div className={clsx(classes.loginForm__circle)}>
            <Icon name={"LockLine"} fontSize={"fs-32"} color={"icon-sub-600"} />
          </div>
        </div>
        <Typography fontType={"label-x-large"}>
          {t("auth.resetPassword.title")}
        </Typography>
        <Typography fontType={"paragraph-medium"} themeColor={"text-sub-600"}>
          {t("auth.resetPassword.description")}
        </Typography>
      </div>
      <ContentDivider className={"w-100"} />
      <FormLayout
        noCancel
        submitButtonProps={{
          type: "resetPassword",
          className: "w-100",
        }}
        onSubmit={handleSubmit(onSubmit)}
        isLoading={isLoading}
        noBack
        noMarginTop
      >
        <Row noBorder>
          <Row.Input>
            <FastPhone
              type={"phoneNumber"}
              control={control}
              name={"phone"}
              isRequired
            />
          </Row.Input>
        </Row>
      </FormLayout>
    </div>
  );
}
